<template>
  <div id="redirect-page">
    <spinner :show="isLoading" class="loading"></spinner>
    <h2>Please close this window to continue...</h2>
  </div>
</template>

<style rel="stylesheet/scss" lang="scss">
  #redirect-page .loading {
    margin-top: 30vh;
  }
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
  h2 {
    margin-top: 1.5rem;
    text-align: center;
  }
</style>

<script>
  import 'hellojs/dist/hello.all'
  import Spinner from '../../components/Spinner.vue'

  export default {
    name: 'redirect-view',
    components: {
      Spinner
    },
    data: function () {
      return {
        isLoading: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Redirect.vue?7ee472aa